exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*h3{font-size: 18px; margin-top: 20px;}*/\n/*button.popup_close { padding: 0; background: none; min-width: 10px; line-height: 5px; float: right; opacity: 0.4; margin-top: 5px;}*/\n/*h2{line-height: 27px;}*/\n/*h2.mat-dialog-title button{color: #222222;}*/\n/*.mat-input-container, .mat-checkbox-label{font-size: 13px;}*/\n\n\n.mat-input-container{width:100%;}\n.red_shape.small_size{height: auto;}\nh2{font-size: 22px; }\n.dialog_width{width: 950px;}\n.mat-select{margin-top: 12px;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/pay-balance/pay-balance.component.css
// module id = ../../../../../src/app/pay-balance/pay-balance.component.css
// module chunks = 39